export default __webpack_public_path__ + "static/board-template1-a9eed37fcb1cadef3e00492f22b6cdf4.png";